export default __webpack_public_path__ + "static/media/payment-method-card-active.2ae19408.svg";